<template>
    <Interval
        :title="$t('karana' + karana.number) + ' (' + karana.lord + ')'"
        :description="karana.number + $t('karana') 
          + ' / ' + formatTime(karana.start) + ' - ' + formatTime(karana.end)"
        :bg="'bg-'+karana.lord.toLowerCase()" :favorable="karana.favorable"
        :start="karana.start" :length="karana.length"
        :scale="scale" :zero="zero" :visibleLeft="visibleLeft"
    />
</template>

<script>
import Interval from '@/components/panchanga/Interval'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'
export default {
  props: ['karana', 'scale', 'zero', 'visibleLeft'],
  components: { Interval },
  mixins: [TimeFormatMixin],
}
</script>

<i18n locale="ru" lang="yaml">
  karana: "-я карана"
  karana1: "Бава"
  karana2: "Балава"
  karana3: "Каулава"
  karana4: "Тайтила"
  karana5: "Гара"
  karana6: "Ваниджа"
  karana7: "Вишти"
  karana8: "Шакуни"
  karana9: "Чатушпада"
  karana10: "Нага"
  karana11: "Кинстугхана"
  diety: "Покровитель"
</i18n>

<i18n locale="en" lang="yaml">
  karana: " karana"
  karana1: "Bava"
  karana2: "Balava"
  karana3: "Kaulava"
  karana4: "Taitila"
  karana5: "Gara"
  karana6: "Vanija"
  karana7: "Vishti"
  karana8: "Shakuni"
  karana9: "Chatushpada"
  karana10: "Naga"
  karana11: "Kinstughana"
  diety: "Diety"
</i18n>
